var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showTab === _vm.OCR_LIST.code
    ? _c("div", [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              { attrs: { "label-position": "left", "label-width": "90px" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "el-form-item-wrapper",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_IdentifyTemplateName")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "150px",
                            "padding-left": "10px"
                          },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.params.templateName,
                            callback: function($$v) {
                              _vm.$set(_vm.params, "templateName", $$v)
                            },
                            expression: "params.templateName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "padding-left": "10px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.initOcrTemplate }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addHandler }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onCopy }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("CargoMsg.Cargo_Copy")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: { click: _vm.onDelete }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "grid-view" }, [
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "261602",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    : _vm.showTab === _vm.OCR_DETAIL.code
    ? _c("ocr-template-config-detail", {
        attrs: {
          "ocr-template": _vm.currentOcrTemplate,
          "initial-action": _vm.action
        },
        on: {
          goBack: function() {
            if (_vm.lastShowTab) {
              _vm.showTab = _vm.lastShowTab
              _vm.lastShowTab = null
            } else {
              _vm.initOcrTemplate()
              _vm.showTab = _vm.OCR_LIST.code
            }
          },
          ocrTemplateSave: function(val) {
            return (_vm.currentOcrTemplate = val)
          }
        }
      })
    : _vm.showTab === _vm.OCR_CODE_HANDLE.code
    ? _c("ocr-code-handle", {
        attrs: { "ocr-template": _vm.currentOcrTemplate },
        on: {
          goBack: function() {
            if (_vm.lastShowTab) {
              _vm.showTab = _vm.lastShowTab
              _vm.lastShowTab = null
            } else {
              _vm.initOcrTemplate()
              _vm.showTab = _vm.OCR_LIST.code
            }
          }
        }
      })
    : _vm.showTab === _vm.OCR_TEST_FILE.code
    ? _c("ocr-test-file", {
        attrs: { "ocr-template": _vm.currentOcrTemplate },
        on: {
          goBack: function() {
            _vm.initOcrTemplate()
            _vm.showTab = _vm.OCR_LIST.code
          },
          jump: function(tab) {
            _vm.showTab = tab
            _vm.lastShowTab = _vm.OCR_TEST_FILE.code
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }